import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityCommentService } from "../../../../../../services/entity-comment/entity-comment.service";

@autoinject
export class DeleteCommentDialog {

    private _id: number;
    private _onCommentDeleted: (id: number) => any;

    constructor(private dialogClientService: DialogClientService,
        private entityCommentService: EntityCommentService) {
    }

    activate(model: { id: number, onCommentDeleted: (id: number) => void }) {
        this._id = model.id;
        this._onCommentDeleted = model.onCommentDeleted;
    }

    close(){
        this.dialogClientService.hide();
    }

    onConfirm(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.entityCommentService.deleteComment(this._id)
                .then(() => {

                    this._onCommentDeleted(this._id);

                    this.dialogClientService.hide();

                    resolve();
                }).catch(() => {
                    reject();
                });
        });
    }
}